import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Testimonial.css";

// import shape from "../../../src/img/Testimonial/shape-bg.png";
import project2 from "../../../src/img/Testimonial/project2.png";
import project1 from "../../../src/img/Testimonial/project1.png";
// import project3 from "../../../src/img/Testimonial/project3.png";
import project4 from "../../../src/img/Testimonial/project4.png";
import project5 from "../../../src/img/Testimonial/project5.png";
import project6 from "../../../src/img/Testimonial/project6.png";

export default function Testimonial(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const options = {
    loop: true,
    margin: 0,
    nav: true,
    animateIn: "bounceInRight",
    animateOut: "bounceOutRight",
    dots: true,
    autoplay: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1000: {
        items: 3,
      },
    },
  };

  return (
    <div>
      <ScreenHeading
        title={"Projects"}
        subHeading={"some of my projects created for learning purpose."}
      />

      <section className="testimonial-section fade-in" id={props.id || ""}>
        <div className="container">
          <div className="row">
            <OwlCarousel
              className="owl-carousel"
              id="testimonial-carousel"
              {...options}
            >
              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testi-comment">
                    <p>
                      <img className="project-img" src={project1} alt="" />
                    </p>
                    <ul className="stars list-unstyled">
                      <div>
                        <p>
                        built a <span className="brand-title">"Netmeds"</span> clone, featuring multiple category pages, routing integration, data storage in local storage,to improve the user experience.
                        </p>
                        <p>Tech Stack : Html | CSS | javascript</p>

                        <span className="span-1">
                          <a
                            href="https://github.com/shaheen-ahmad2601/netmeds-unit-2-updated"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-1">Source Code</button>
                          </a>
                        </span>

                        <span>
                          <a
                            href="https://zippy-kitsune-2c37d4.netlify.app/"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-2">Deployment</button>
                          </a>
                        </span>
                      </div>
                    </ul>
                  </div>
                  <div className="flex"></div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testi-comment">
                    <p>
                      <img className="project-img" src={project2} alt="" />
                    </p>
                    <ul className="stars list-unstyled">
                      <div>
                        <p>
                        created a <span className="brand-title">"Mamaearth"</span> clone, focusing on different pages, implemented different functionalities, optimizing for better usability.
                        </p>
                        <p>Tech Stack : Html | CSS | javascript</p>

                        <span className="span-2">
                          <a
                            href="https://github.com/shaheen-ahmad2601/unit-3-project-mamaearth"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-1">Source Code</button>
                          </a>
                        </span>

                        <span>
                          <a
                            href="https://shiny-lokum-c2cece.netlify.app/"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-2">Deployment</button>
                          </a>
                        </span>
                      </div>
                    </ul>
                  </div>
                  <div className="client-info"></div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testi-comment">
                    <p>
                      <img className="project-img" src={project4} alt="" />
                    </p>
                    <ul className="stars list-unstyled">
                      <div>
                        <p>
                        The <span className="brand-title">"To-Do App"</span> is designed to efficiently manage and track daily tasks.  it allows seamless task organization and progress monitoring for enhanced productivity
                        </p>
                        <p>Tech Stack : ReactJS | CSS</p>

                        <span className="span-1">
                          <a
                            href="https://github.com/shaheen-ahmad2601/TodoList-reactjs/tree/master/React-TodoList"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-1">Source Code</button>
                          </a>
                        </span>

                        <span>
                          <a
                            href="https://aquamarine-piroshki-8eaf30.netlify.app/"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-2">Deployment</button>
                          </a>
                        </span>
                      </div>
                    </ul>
                  </div>
                  <div className="flex"></div>
                </div>
              </div>

        

              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testi-comment">
                    <p>
                      <img className="project-img" src={project5} alt="" />
                    </p>
                    <ul className="stars list-unstyled">
                      <div>
                        <p>
                        <span className="brand-title">"Project-Nordstrom-Rack"</span>. Its an American clothing
                          and accessories brand, in which I've worked
                          upon product pages, UI design and different functionalities.
                        </p>
                        <p>Tech Stack : React JS | Node JS | CSS</p>

                        <span className="span-2">
                          <a
                            href="https://github.com/shaheen-ahmad2601/Nordstromrack-Clone"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-1">Source Code</button>
                          </a>
                        </span>

                        <span>
                          <a
                            href="https://nordstrom-rack.netlify.app/"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-2">Deployment</button>
                          </a>
                        </span>
                      </div>
                    </ul>
                  </div>
                  <div className="client-info"></div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testi-comment">
                    <p>
                      <img className="project-img" src={project6} alt="" />
                    </p>
                    <ul className="stars list-unstyled">
                      <div>
                        <p>
                        I designed and developed an <span className="brand-title">"Adidas"</span>  clone, incorporating multiple category pages, add-to-cart functionality, and integrating checkout and payment features.
                        </p>
                        <p>Tech Stack : React | TS |TailwindCss</p>

                        <span className="span-2">
                          <a
                            href="https://github.com/shaheen-ahmad2601/Adidas-clone-Project"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-1">Source Code</button>
                          </a>
                        </span>

                        <span>
                          <a
                            href="https://adidas-projects.netlify.app/"
                            target="_blank" rel="noreferrer"
                          >
                            <button className="btn-2">Deployment</button>
                          </a>
                        </span>
                      </div>
                    </ul>
                  </div>
                  <div className="client-info"></div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </section>

      <div className="style-div"></div>
      <div className="style-div1"></div>

      <div className="footer-image">
        <img src="" alt="Phot0 not responding" />
      </div> 
    </div>
  );
}

// eslint-disable-next-line no-lone-blocks

